import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import banner1 from '../../../assets/images/banner1.jpg'
// import apple from "../../../assets/images/home/apple.webp";
// import insta from "../../../assets/images/home/insta.webp";
// import linked from "../../../assets/images/home/linked.webp";
// import store from "../../../assets/images/home/store.webp";
import banner from "../../../assets/images/home/SaintLaurent.webp";
import banner1 from "../../../assets/images/home/c1 (1).webp";
import banner1new from "../../../assets/images/newwebbannerfirstt.webp";
import banner2new from "../../../assets/images/banner2neww.webp";

import banner1phone from "../../../assets/images/home/c2 (1).webp";
import bannerphone from "../../../assets/images/home/SaintLaurentp.webp";
// import 'intersection-observer';
import DownloadModal from "../../Modals/DownloadModal";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  getAllProductOnline,
  getLastDoc,
} from "../../../features/Products/ProductSlice";
import { Carousel } from "react-bootstrap";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const placeholderClass = "placeholder-image";
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const myStyle = {
    backgroundImage: `url(${banner})`,
    //fontSize:'50px',
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    // height: "75%",
  };
  const myStyle1 = {
    backgroundImage: `url(${banner1})`,
    //fontSize:'50px',
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    // height: "75%",
  };
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  useEffect(() => {
    dispatch(SortProducts(""));

    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(getAllProductOnline([]));
    dispatch(getLastDoc(null));
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % 2); // 2 = number of slides
    }, 15000); // 15 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  return (
    <>
      {/* Desktop */}
      <div
        className="d-md-block d-none justify-content-center px-0 pb-5"
        style={{ height: "40vw" }}
      >
        <div className="row">
          <div className="show-modal-download">
            {show && <DownloadModal show={show} setShow={setShow} />}
          </div>
          <div className="col-12 justify-content-center align-items-center px-0 montserrat-font">
            <div
              className="row justify-content-center mx-0"
              style={{ position: "relative" }}
            >
              <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                controls={false}
              >
                <Carousel.Item>
                  <div className="row" style={{ backgroundColor: "#2A0909" }}>
                    <div className="col-6 p-0 m-0">
                      <img
                        loading="lazy"
                        src={banner1new}
                        alt="The Céline Triomphe Panier (left) and Hermès slippers (right)"
                        className="w-100 img-fit-height banner-desktop"
                      />
                    </div>

                    <div className="col-6 p-2 m-0">
                      <div
                        className="carousel-txt"
                        style={{
                          marginLeft: "15px",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <p
                            className="carousel-txt-title"
                            style={{
                              marginBottom: "0",
                              fontSize: "20px",
                              fontWeight: "400",
                            }}
                          >
                            {t("Luxuryforless")}
                          </p>
                          <div
                            className="carousel-txt-title-hr"
                            style={{
                              position: "relative",
                              top: "10px",
                            }}
                          ></div>
                        </div>

                        {/* No vertical space between heading and subheading */}
                        <p
                          className="carousel-txt-subtitle montserrat-font  carousel-txt-subtitle-bigscreen"
                          style={{
                            lineHeight: "110.1%",
                            marginTop: "2px",
                            marginBottom: "0",
                            padding: "0",
                          }}
                        >
                          {i18n.language === "ar" ? (
                            <>
                              حقائب خالدة. حيث تلتقي <br /> الحقائب الأيقونية
                              بالتسوق الذكي.
                            </>
                          ) : (
                            <>
                              Timeless Bags. Where Iconic{" "}
                              <br className="banner1" /> Bags Meet Smart Buys.
                            </>
                          )}
                        </p>
                        <p
                          className=" montserrat-font banner-title-2 "
                          style={{
                            // lineHeight: "110.1%",
                            marginTop: "12px",
                            marginBottom: "0",
                            padding: "0",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "#FFFFFF",
                          }}
                        >
                          {i18n.language === "ar"
                            ? "خصومات تصل إلى 70٪. أصلية 100٪. تم التحقق منها من قبل الخبراء."
                            : "Up to 70% Off. 100% Authentic. "}
                        </p>
                        <div
                          onClick={() => {
                            navigate(
                              "/products?topic=pricedrops&id=AqFLulu9y2m4mqEIkch1&"
                            );
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth", // Changed from "instant" to "smooth"
                            });
                          }}
                          className="carousel-btn btn-top-bigscreen"
                          style={arabStyle}
                        >
                          {t("emptybag3")}
                        </div>
                      </div>

                      <div
                        className="custom-indicators-container"
                        style={{
                          marginLeft: "15px",
                        }}
                      >
                        <button
                          className={`custom-indicators ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => handleSelect(0)}
                        ></button>
                        <button
                          className={`custom-indicators ${
                            index === 1 ? "active" : ""
                          }`}
                          onClick={() => handleSelect(1)}
                        ></button>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="row" style={{ backgroundColor: "#2A0909" }}>
                    <div className="col-6 p-0 m-0">
                      <img
                        loading="lazy"
                        // src="/bannerfirst.webp"
                        src={banner2new}
                        alt="The Céline Triomphe Panier (left) and Hermès slippers (right)"
                        className="w-100 img-fit-height banner-desktop"
                      />
                    </div>
                    <div className="col-6 p-2 m-0">
                      <div
                        className="carousel-txt"
                        style={{
                          marginLeft: "15px",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <p
                            className="carousel-txt-title"
                            style={{
                              marginBottom: "0",
                              fontSize: "20px",
                              fontWeight: "400",
                            }}
                          >
                            {i18n.language === "ar"
                              ? "حوّل العناصر الفاخرة إلى نقود"
                              : "Turn Luxury Items Into Cash"}
                          </p>
                          <div
                            className="carousel-txt-title-hr"
                            style={{
                              position: "relative",
                              top: "10px",
                            }}
                          ></div>
                        </div>

                        {/* No vertical space between heading and subheading */}
                        <p
                          className="carousel-txt-subtitle montserrat-font"
                          style={{
                            lineHeight: "0.6",
                            marginTop: "4px",
                            marginBottom: "0",
                            padding: "0",
                          }}
                        >
                          {i18n.language === "ar"
                            ? "احصل على ما يصل إلى 90٪ من قيمتها"
                            : "Unlock up to 90% of its value"}
                        </p>
                        <p
                          style={{
                            marginTop: "6px",
                            marginBottom: "0",
                            padding: "0",
                            color: "#FFFFFF",
                            fontWeight: "400",
                            fontSize: "16px",
                          }}
                        >
                          {i18n.language === "ar"
                            ? "إدراج فوري · استلام مجاني · عملية خالية من المتاعب"
                            : "Instant Listing · Free Pickup · Hassle-Free Process"}
                        </p>

                        <div
                          onClick={() => {
                            // navigate(
                            //   "/products?topic=pricedrops"
                            //   // "/products?brand=UXo5X4BP3lMoimmkMNrO&nameBrand=Saint%20Laurent&"
                            // );
                            navigate("/how-to-sell");
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth", // Changed from "instant" to "smooth"
                            });
                          }}
                          className="carousel-btn btn-top-bigscreen"
                          style={arabStyle}
                        >
                          {i18n.language === "ar" ? "بيع عنصر" : "Sell an Item"}
                        </div>
                      </div>

                      <div
                        className="custom-indicators-container"
                        style={{
                          marginLeft: "15px",
                        }}
                      >
                        <button
                          className={`custom-indicators ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => handleSelect(0)}
                        ></button>
                        <button
                          className={`custom-indicators ${
                            index === 1 ? "active" : ""
                          }`}
                          onClick={() => handleSelect(1)}
                        ></button>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
